<template>
  <div class="d-flex justify-center border-top">
    <div>&copy; 2002-2020 Earcon S.L.</div>
    <div class="separator">|</div>
    <div>Sant Boi de Llobregat</div>
    <div class="separator">|</div>
    <div>Contact</div>
    <div class="separator">|</div>
    <div>Help</div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
